/** The page sizes a paginated table offers unless a caller passes its own list. */
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100]
